module.exports = __webpack_public_path__ + "img/medellin.37a236f4.jpg";